import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { storage } from '@service-initiation/shared-utils-jotai';

import { type DeviceType as StorageDeviceType } from '../types';
import { availableDeviceTypeAsyncAtom } from './availableDeviceTypesAsyncAtom';

export const deviceTypeAtom = atomWithStorage<StorageDeviceType | undefined>(
  'si-tec-car-device-type',
  undefined,
  storage<StorageDeviceType | undefined>(),
  {
    getOnInit: true,
  }
);

export const selectedDeviceTypeAsyncAtom = atom(async (get) => {
  const deviceType = get(deviceTypeAtom);
  const devices = await get(availableDeviceTypeAsyncAtom(deviceType?.id));

  const device = devices
    ? devices.find((d) => d.id === deviceType?.id)
    : undefined;
  const rootParent =
    devices && device
      ? devices.find((d) => d.id === device.rootParentDeviceTypeId)
      : undefined;

  return rootParent
    ? ({ id: rootParent.id, name: rootParent.name } as StorageDeviceType)
    : undefined;
});
